<script>
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import { CreditCard } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { offer, onSelect, loading = false, class: className } = $props()

</script>

<!-- Stripe card payment — always shows offer price with a direct checkout button -->
<div class={cn(
  'flex flex-col justify-center items-center gap-4 w-full rounded-lg border-2 border-gray-200 bg-white px-5 py-6 text-center',
  className
)}>

  <!-- Icon -->
  <div class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-50">
    <CreditCard size={20} class="text-primary-600" />
  </div>

  <!-- Title and description -->
  <div class="flex flex-col items-center gap-2">
    <span class="rounded-full bg-green-50 px-3 py-1 text-xs font-medium text-green-700 border border-green-200">Immediate access</span>
    <Text variant="section_title" text="Pay by card" class="mt-1" />
    <Text variant="label" as="span" class="text-gray-500">Secure Stripe checkout</Text>
  </div>

  <!-- Checkout button with price -->
  <Button
    variant="submit"
    text={loading ? 'Opening checkout...' : 'Get full access'}
    onclick={onSelect}
    {loading}
    class="cursor-pointer"
  />

  <span class="text-smaller text-gray-500/80 italic">You will be redirected to Stripe to complete your payment.</span>

</div>
